import { PressureOptKey } from "components/containers/inspectionSetting/containers/templateBuilder/fields/device-pressure/previewer";
import BasePeripheral from "./BasePeripheral";
import dayjs from "config/dayjs";
import { formatDate, PressureResponse, SupportHandlers } from "./type";

class Pressure extends BasePeripheral {
  protected name = SupportHandlers.requestDeviceDataAtNeptune;

  public onResponse(callback: (data: PressureResponse) => void) {
    this.addListener(({ result, identify_info }) => {
      callback({ data: this.transform(result), identify_info });
    });
  }

  public request(identify_info: string) {
    return this.callHandler(identify_info, { type: "1" });
  }

  public transform(data: any) {
    return {
      [PressureOptKey.START_DATE]: this.formatDate(data.start_date),
      [PressureOptKey.START_VALUE]: data.start_value,
      [PressureOptKey.END_DATE]: this.formatDate(data.end_date),
      [PressureOptKey.END_VALUE]: data.end_value,
    };
  }

  protected formatDate(date: number) {
    return dayjs(date * 1000).format(formatDate);
  }
}

export default Pressure;
